import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'post'

export default class OspreyTemplatesTagsApply extends BaseAction {
    constructor(dataKey) {
        const id = 'd615f37f-2880-4a7d-92b3-f6b62f8a7474'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    applyTagToTemplate(params) {
        const { templateId, tagIdList } = params

        this.path = `/${resource}/${templateId}/tags`

        this.params = {
            tagIdList
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-tags-apply.js